import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "input-group-text"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = ["type", "required", "maxlength", "placeholder", "value"];
const _hoisted_5 = {
  key: 1,
  style: {
    "padding-left": "0.5rem"
  }
};
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback",
  style: {
    "display": "block"
  }
};
const _hoisted_7 = {
  key: 1,
  class: "invalid-feedback",
  style: {
    "display": "block"
  }
};
import { isEmpty, message, toDot, unDot } from '@/common/utils/Util';
import { ref, toRef, toRefs, computed } from 'vue';
const __default__ = {
  name: 'appg-input'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    modelValue: String,
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)'
    },
    group: {
      type: Boolean,
      description: 'Whether input is an input group (manual override in special cases)'
    },
    placeHolder: {
      type: String,
      default: ''
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: true
    },
    alternative: {
      type: Boolean,
      description: 'Whether input is of alternative layout'
    },
    label: {
      type: String,
      description: 'Input label (text before input)'
    },
    inValidMessage: {
      type: String,
      description: 'Input error (below input)',
      default: '필수항목입니다.'
    },
    successMessage: {
      type: String,
      description: 'Input success message',
      default: ''
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes',
      default: 'form-control-label'
    },
    inputClasses: {
      type: String,
      description: 'Input css classes'
    },
    inputGroupClasses: {
      type: String,
      description: 'Input group css classes'
    },
    value: {
      type: [String, Number],
      description: 'Input value'
    },
    type: {
      type: String,
      description: 'Input type',
      default: 'text'
    },
    appendIcon: {
      type: String,
      description: 'Append icon (right)'
    },
    prependIcon: {
      type: String,
      description: 'Prepend icon (left)'
    },
    maxLength: {
      type: [String, Number],
      description: 'Limited Max Length',
      default: ''
    },
    isFormGroup: {
      type: Boolean,
      description: 'Whether is form-group className',
      default: true
    },
    isFormInline: {
      type: Boolean,
      description: 'form-inline className'
    },
    inlineHeadText: {
      type: String,
      description: 'inline head text'
    },
    inlineTailText: {
      type: String,
      description: 'inline tail text'
    },
    isInlineBlock: {
      type: Boolean,
      description: 'display inline-block'
    },
    span: {
      type: String,
      description: 'small text',
      default: ''
    },
    _class: {
      type: String,
      default: ''
    },
    isDotted: {
      type: Boolean,
      default: false
    },
    validSet: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  setup(__props, {
    emit: __emit
  }) {
    const inheritAttrs = ref(false);
    const props = __props;
    const emits = __emit;
    const {
      valid,
      inValidMessage,
      modelValue
    } = toRefs(props);
    const innerValue = computed(() => {
      if (props.isDotted) {
        return toDot(modelValue.value);
      } else return modelValue.value;
    });
    const focused = ref(false);
    const slotData = () => computed(() => {
      return {
        focused: this.focused,
        inValidMessage: this.inValidMessage,
        ...this.listeners
      };
    });
    const hasIcon = () => computed(() => {
      const {
        append,
        prepend
      } = this.$slots;
      return append !== undefined || prepend !== undefined || this.appendIcon !== undefined || this.prependIcon !== undefined || this.group;
    });
    function updateValue({
      target
    }) {
      const {
        value
      } = target;
      if (props.isDotted) {
        if (value.replaceAll(',', '') !== innerValue.value) {
          emits('update:modelValue', unDot(value));
        }
      } else if (props.type === 'number' && !isEmpty(props.maxLength) && value.length > props.maxLength) {
        target.value = value.slice(0, props.maxLength);
        emits('update:modelValue', value.slice(0, props.maxLength));
      } else emits('update:modelValue', value);
    }
    function onFocus(evt) {
      this.focused = true;
      emits('focus', evt);
    }
    function onBlur(evt) {
      this.focused = false;
      emits('blur', evt);
    }
    return (_ctx, _cache) => {
      const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{
          'form-group': __props.isFormGroup,
          'd-inline-block': __props.isInlineBlock
        }, __props._class])
      }, [_renderSlot(_ctx.$slots, "label", {}, () => [__props.label ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass([__props.labelClasses, "d-flex"])
      }, [_createElementVNode("h6", null, _toDisplayString(__props.label), 1), __props.required ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*")) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "span", {}, () => [__props.span ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(__props.labelClasses),
        style: {
          "font-size": "0.75rem"
        }
      }, _toDisplayString(__props.span), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: _normalizeClass([{
          'input-group': hasIcon
        }, {
          focused: focused.value
        }, {
          'input-group-alternative': __props.alternative
        }, {
          'has-label': __props.label || _ctx.$slots.label
        }, {
          'is-invalid': !_unref(valid) || __props.validSet?.$error
        }, {
          'form-inline': __props.isFormInline
        }, __props.inputGroupClasses])
      }, [__props.prependIcon || _ctx.$slots.prepend ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createElementVNode("i", {
        class: _normalizeClass(__props.prependIcon)
      }, null, 2)])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", _mergeProps(slotData, {
        valid: _unref(valid)
      }), () => [__props.inlineHeadText ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.inlineHeadText), 1)) : _createCommentVNode("", true), _createElementVNode("input", _mergeProps({
        type: __props.type
      }, _ctx.$attrs, {
        required: __props.required,
        class: ["form-control", [{
          'is-invalid': !_unref(valid) || __props.validSet?.$error
        }, __props.inputClasses]],
        maxlength: __props.maxLength,
        placeholder: __props.placeHolder,
        value: _unref(modelValue),
        onInput: updateValue
      }), null, 16, _hoisted_4), __props.inlineTailText ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.inlineTailText), 1)) : _createCommentVNode("", true)]), _renderSlot(_ctx.$slots, "button"), __props.appendIcon || _ctx.$slots.append ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass(["input-group-text", [{
          'is-invalid': !_unref(valid) || __props.validSet?.$error
        }]])
      }, [__props.appendIcon ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
        key: 0,
        icon: __props.appendIcon
      }, null, 8, ["icon"])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "append")], 2)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "infoBlock"), _renderSlot(_ctx.$slots, "error", {}, () => [_unref(inValidMessage) && !_unref(valid) ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(inValidMessage)), 1)) : _createCommentVNode("", true), __props.validSet?.$error ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(message)(__props.validSet)), 1)) : _createCommentVNode("", true)])], 2)], 2);
    };
  }
});